import '../css/app.css';
import './bootstrap';
import 'swiper/css';
import 'swiper/css/navigation';

import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { ThemeProvider } from '@/Contexts/ThemeContext';
import GlobalRedirectLoader from '@/Components/GlobalRedirectLoader';
import GlobalToasts from '@/Components/GlobalToasts';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.jsx`,
            import.meta.glob('./Pages/**/*.jsx'),
        ),
    setup({ el, App, props }) {
    // (419 handler centralizado en bootstrap.js)

        const AppWithTheme = () => (
            <ThemeProvider>
                <GlobalRedirectLoader />
                <App {...props} />
                <GlobalToasts />
            </ThemeProvider>
        );

        if (import.meta.env.SSR) {
            hydrateRoot(el, <AppWithTheme />);
            return;
        }

        createRoot(el).render(<AppWithTheme />);
    },
    progress: {
        color: '#4B5563',
    },
});
